import { Button } from '@mui/material';
import type { Control, FieldValues } from 'react-hook-form';
import type { UseMutationResult } from 'react-query';
import { useQueryClient } from 'react-query';
import { queryKeys } from '../../../../../services/query-key/query-keys';
import { runMutation } from '../../../../../utils/vy-mutation';
import type { ToastRenderType } from '../../../../../utils/vy-toasts/vy-toast-types';

type IntegrationFooterProps<FormValues extends FieldValues> = {
  control: Control<FormValues>;
  mutate: UseMutationResult<unknown, unknown, FormValues>;
  buttonLabel: string;
  toastMessages: ToastRenderType<unknown, unknown>;
};

export const IntegrationFooter = <T extends FieldValues>({
  control,
  mutate,
  buttonLabel,
  toastMessages,
}: IntegrationFooterProps<T>) => {
  const queryClient = useQueryClient();

  const { handleSubmit } = control;
  const submitHandler = handleSubmit((formValues) =>
    runMutation(mutate, { ...formValues }, toastMessages, {
      onSuccess: () => queryClient.invalidateQueries(queryKeys.connectedIntegrations()),
    }),
  );

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button variant="contained" onClick={submitHandler}>
        {buttonLabel}
      </Button>
    </div>
  );
};
